export const highlightText = ({ content, highlight }: { content: string; highlight?: string }) => {
  if (!highlight || !highlight.trim()) {
    return <span>{content}</span>;
  }

  const regex = new RegExp(`(${highlight})`, "gi");
  const parts = content.split(regex);

  return (
    <span>
      {parts.map((part, i) => (regex.test(part) ? <mark key={i}>{part}</mark> : <span key={i}>{part}</span>))}
    </span>
  );
};
